<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Boleto Anulado</pre>
            <table style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;"> 
              <tr>    
                <td style="padding: 2px; font-weight:600;">Boleto:</td>
                <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.id }}</td>  
              </tr> 
              <tr>    
                <td style="padding: 2px; font-weight:600;">Monto:</td>
                <td style="padding: 2px; text-transform: uppercase; font-weight:800;">${{monto}}</td>  
              </tr>
              <tr>    
                <td style="padding: 2px; font-weight:600;">Fecha de anulación:</td>
                <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ Date.now() | moment('DD-MM-YYYY hh:mm:ss') }}</td>  
              </tr> 
              <tr>    
                <td style="padding: 2px; font-weight:600;">Impreso por:</td>
                <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{user.username}}</td>  
              </tr>  
            </table>
        </body>
      </html>
</template>
<script>
export default {
  props: {
    boleto: {required: false},
    user: {required: false},
    monto: {required: false},
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
}
</script>
<style scoped> 
</style>